<div class="error-panel">
	<i class="fal fa-exclamation-triangle fa-4x error-color"></i>
	<p>
		An error has occurred trying to access this task or form. If you feel this was
		in error please contact support.
	</p>
</div>
